import { dataDogLogger } from 'platform/monitoring/Datadog/utilities';
import { useEffect, useRef } from 'react';

export const useMissingInfoDiagnostics = ({ formData = {}, pathname }) => {
  const hasLoggedRef = useRef(false);
  const missingGuestInfo =
    !formData['view:isLoggedIn'] && !formData['view:veteranInformation'];

  useEffect(() => {
    if (!missingGuestInfo || hasLoggedRef.current) return;

    dataDogLogger({
      message: '10-10ez missing guest info on personal info page',
      attributes: {
        path: pathname,
        hasGuestInfo: false,
        formDataKeys: Object.keys(formData),
        isLoggedInViewField: formData['view:isLoggedIn'],
        hasVeteranDateOfBirth: Boolean(formData.veteranDateOfBirth),
      },
      status: 'warn',
    });

    hasLoggedRef.current = true;
  }, [missingGuestInfo, formData, pathname]);
};
